<template>
    <rkm-overlay>
         <rkm-layout-body title="Paciente em observação">
            <template
                v-if="loaded"
                v-slot:center
            >
                <rkm-button
                    v-if="model.dorToracica"
                    color="warning"
                >
                    Dor torácica
                </rkm-button>

                <rkm-button
                    v-if="model.alergias.length > 0"
                    @click="scrollToAlergias()"
                    color="alergia"
                >
                    Paciente alérgico
                </rkm-button>
            </template>

            <template
                v-if="loaded"
                v-slot:actions
            >
                <rkm-button
                    color="danger"
                    @click.stop="exit()"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="handleDesfecho()"
                    color="outline-success"
                    v-if="!form.atendimentoMedico.solicitouReavaliacao"
                >
                    Desfecho
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.handleDesfecho()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="form.paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="form.paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ form.paciente.nome }} <strong>({{ form.paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ form.paciente.nome }},
                    </span>
                    <span v-if="form.paciente.idade">
                        {{ form.paciente.idade.anos }} anos,
                        {{ form.paciente.idade.meses }} meses
                        e {{ form.paciente.idade.dias }} dias,
                    </span>
                    <span>{{ form.paciente.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content v-if="loaded">
                <Form
                    ref="Form"
                    :plantao-id="$route.params.plantaoId"
                    :data="{ form, model, additionals }"
                    @save="redirectToList()"
                />
            </rkm-layout-content>
        </rkm-layout-body>

        <ModalFinalizarAtendimento
            :plantao-id="$route.params.plantaoId"
            :data="{ form, model }"
            ref="ModalFinalizarAtendimento"
            @save="redirectToList()"
        />
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/pronto-atendimento/observacao/Form'
import ModalFinalizarAtendimento from '@/components/pronto-atendimento/observacao/components/finalizar-atendimento/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Vuex
import { mapActions } from 'vuex'

// Enums.
import statusExame from '@/enums/pronto-atendimento/statusExame'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Moment.
import moment from 'moment'

export default {
    components: { Form, ModalFinalizarAtendimento },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            pacienteObservacao: this.getConectaSusRepository('prontoAtendimento.observacao')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: {},
        model: {},
        additionals: {},
        enums: { statusExame, preferenciaNome }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        load() {

            this.setLoading()

            this.repositories.pacienteObservacao.create(this.$route.params.id)
                .then(({ data }) => {

                    if (data.model.finalizacao.obito.obitoEm) {

                        const obitoEm = moment(data.model.finalizacao.obito.obitoEm, 'YYYY-MM-DD HH:mm:ss')

                        data.model.finalizacao.obito.dataObito = obitoEm.toDate()
                        data.model.finalizacao.obito.horaObito = obitoEm.format('HH:mm')
                    }

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exit() {

            this.showExitConfirmation(async () => this.redirectToList())
        },
        redirectToList() {

            this.unsetShowExitFormConfirmation()

            this.$router.push({ name: 'pronto-atendimento-paciente-observacao-index' })
        },
        handleDesfecho() {

            if (this.hasSolicitacaoExameNaoRealizada()) {

                this.showSolicitacaoExamesConfirmation(() => {

                    if (this.hasPrescricaoInternaNaoRealizada()) {

                        this.$nextTick().then(() => {

                            this.showPrescricaoInternaConfirmation(() => {

                                if (this.hasServicoEnfermagemNaoRealizado()) {

                                    this.$nextTick().then(() => {

                                        this.showServicoEnfermagemConfirmation(() => {

                                            this.$refs.ModalFinalizarAtendimento.open()
                                        })
                                    })
                                }
                                else {

                                    this.$refs.ModalFinalizarAtendimento.open()
                                }
                            })
                        })
                    }
                    else if (this.hasServicoEnfermagemNaoRealizado()) {

                        this.$nextTick().then(() => {

                            this.showServicoEnfermagemConfirmation(() => {

                                this.$refs.ModalFinalizarAtendimento.open()
                            })
                        })
                    }
                    else {

                        this.$refs.ModalFinalizarAtendimento.open()
                    }
                })
            }
            else if (this.hasPrescricaoInternaNaoRealizada()) {

                this.showPrescricaoInternaConfirmation(() => {

                    if (this.hasServicoEnfermagemNaoRealizado()) {

                        this.$nextTick().then(() => {

                            this.showServicoEnfermagemConfirmation(() => {

                                this.$refs.ModalFinalizarAtendimento.open()
                            })
                        })
                    }
                    else {

                        this.$refs.ModalFinalizarAtendimento.open()
                    }
                })
            }
            else if (this.hasServicoEnfermagemNaoRealizado()) {

                this.showServicoEnfermagemConfirmation(() => {

                    this.$refs.ModalFinalizarAtendimento.open()
                })
            }
            else {

                this.$refs.ModalFinalizarAtendimento.open()
            }
        },
        showSolicitacaoExamesConfirmation(callback) {

            this.showConfirmation(
                'Há um ou mais exames solicitados. Se continuar com o desfecho, '
                    + 'não será possível realizar o exame. Deseja realmente continuar?',
                async () => callback()
            )
        },
        showPrescricaoInternaConfirmation(callback) {

            this.showConfirmation(
                'Há uma ou mais prescrições interna solicitadas. Se continuar com o desfecho, '
                    + 'não será possível atender a prescrição. Deseja realmente continuar?',
                async () => callback()
            )
        },
        showServicoEnfermagemConfirmation(callback) {

            this.showConfirmation(
                'Há um ou mais serviços de enfermagem solicitados. Se continuar com o desfecho, '
                    + 'não será possível atender ao serviço. Deseja realmente continuar?',
                async () => callback()
            )
        },
        hasSolicitacaoExameNaoRealizada() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.pedidosExames.concat(this.model.pedidosExames)
                .find(p => p.exames.find(e => !e.status || !status.includes(e.status.id)))
        },
        hasPrescricaoInternaNaoRealizada() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.prescricoesInterna.concat(this.model.prescricoesInterna).find(p => p.medicamentos
                .find(m => !m.aplicacoes || m.aplicacoes.find(a => !status.includes(a.status.id))))
        },
        hasServicoEnfermagemNaoRealizado() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.servicosEnfermagem.concat(this.model.servicosEnfermagem)
                .find(s => !status.includes(s.status.id))
        },
        scrollToAlergias() {

            const element = document.querySelector('#alergias')

            element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        },
    },
    mixins: [error, repository]
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>